import '../bootstrap'
import {CustomConfirmLogout} from "functions/CustomConfirm";
import * as Turbolinks from "@hotwired/turbo"
import {closeAllDropDown, registerCustomElements} from "functions/window";
import {initDropdown} from "functions/dropdown";
import {showNotificationList} from "functions/helper";
import {$} from "functions/dom";
import {initShortcuts} from "functions/shortcuts";

/**
 * Register all custom elements
 */
registerCustomElements()

/**
 * Initialisation des shortcuts
 */
initShortcuts()

document.addEventListener("turbo:load", function () {

        if ($(".table-list table")) {
            import('functions/responsiveTableRefactor').then((module) => {
                module.responsiveTableRefactor()
            }).catch(error => {
                console.error('Error loading custom function:', error);
            });
        }

        /**
         * Sticky Header
         * @type {Element}
         */
        const navMenu = document.querySelector(".nav_menu");
        let isScrolling = false;

        window.addEventListener("scroll", () => {
            if (!isScrolling) {
                isScrolling = true;
                window.requestAnimationFrame(() => {
                    // Ajoute ou retire la classe "sticky" en fonction de la position du scroll
                    if (window.scrollY > 0) {
                        navMenu.classList.add("sticky");
                    } else {
                        navMenu.classList.remove("sticky");
                    }
                    isScrolling = false;
                });
            }
        });


        /**
         * Notification Toast
         */
        if (typeof notification !== 'undefined' && notification !== null) {
            import('functions/NotificationToast').then((module) => {
                let message = notification
                if (message) {
                    module.NotificationToast(message.type, message.message)
                    message = null
                }
            }).catch(error => {
                console.error('Error loading custom function:', error);
            });
        }

        /**
         * Initialisation des tooltips
         */
        if ($("[data-tooltip]")) {
            import('functions/tooltip').then((module) => {
                module.tooltip()
            }).catch(error => {
                console.error('Error loading custom function:', error);
            })
        }

        if ($("[data-tooltipinteractive]")) {
            import('functions/tooltip').then((module) => {
                module.tooltipInteractive()
            }).catch(error => {
                console.error('Error loading custom function:', error);
            });
        }


        /**
         * Initailisation initMeiliSearch
         */
        // initMeiliSearch()


        /**
         * Initailisation des dropdown
         */
        initDropdown()
        if ($(".table_drop_action")) {
            import('functions/dropdown').then((module) => {
                module.tableDropdownAction()
            }).catch(error => {
                console.error('Error loading custom function:', error);
            });
        }

        /**
         * Fermeture des dropdown au click sur element externe
         */
        closeAllDropDown()


        /**
         * Dialog de confirmation lors de suppresion de donnée
         */
        if ($(".deleteForm")) {
            import('functions/helper').then((module) => {
                module.confirmationDialogDelete()
            }).catch(error => {
                console.error('Error loading custom function:', error);
            });
        }


        /**
         * Affiche la liste des derniers notification
         */
        showNotificationList()


        /**
         *  Initialisation des graphiques (Chart, Dognhut)
         */
        if ($("#chart__stats_year")) {
            import('functions/chart').then((module) => {
                module.initChartGraph()
            }).catch(error => {
                console.error('Error loading custom function:', error);
            });
        }


        // Gestion de bar de recherche
        if ($("input[is='search-complete']")) {
            import('functions/searchComplete').then((module) => {
                module.initSearchComplete()
            }).catch(error => {
                console.error('Error loading custom function:', error);
            });
        }


        /**
         * Dom form toggle mode (Edit/Show)
         */
        if ($(".toggle-form-switch")) {
            import('functions/form').then((module) => {
                module.toggleFormMode()
            }).catch(error => {
                console.error('Error loading custom function:', error);
            });
        }

        /**
         * Submit form in AJAX
         */
        if ($("form.custom__form")) {
            import('functions/form').then((module) => {
                module.formSubmitInAjax()
            }).catch(error => {
                console.error('Error loading custom function:', error);
            });
        }

        /**
         * Initialisation de la page des missions collective
         */
        if ($("form#missions_collect_form")) {
            import('modules/missions').then((module) => {
                module.initMissionPage()
            }).catch(error => {
                console.error('Error loading custom function:', error);
            });
        }

        /**
         * Initialisation de la page des decision de conges collective
         */
        if ($("form#decision_conge_form")) {
            import('modules/conges').then((module) => {
                module.initDecisionCongePage()
            }).catch(error => {
                console.error('Error loading custom function:', error);
            });
        }

        /**
         * Initialisation de la page des activity de l'utilisateur
         */
        if ($("#user_activity_table")) {
            import('modules/userHistory').then((module) => {
                module.initUserActivityHistory()
            }).catch(error => {
                console.error('Error loading custom function:', error);
            });
        }

        /**
         * Form password input toggle visibility
         */
        if ($("#passswordToggle")) {
            import('functions/form').then((module) => {
                module.formPasswordToggle()
            }).catch(error => {
                console.error('Error loading custom function:', error);
            });
        }


        /**
         * Initialisation de boite de dialog modal
         */
        if ($(".openModalBox")) {
            import('functions/modal').then((module) => {
                module.initModalBox()
            }).catch(error => {
                console.error('Error loading custom function:', error);
            });
        }

        /**
         * Check all table row data
         */
        if ($(".checkboxAll")) {
            import('functions/helper').then((module) => {
                module.checkTableAllRow()
            }).catch(error => {
                console.error('Error loading custom function:', error);
            });
        }

        /**
         * Generation animation form excel export file
         */
        if ($(".excel_export_link")) {
            import('functions/helper').then((module) => {
                module.exportXlsxFile()
            }).catch(error => {
                console.error('Error loading custom function:', error);
            });
        }

        /**
         * Logout button
         * @type {Element}
         */
        let logout = document.querySelector(".logout");
        logout?.addEventListener("submit", (e) => {
            e.preventDefault();
            CustomConfirmLogout(logout.id)
        })

        /**
         * Redirect link to Turbolink
         * @type {NodeListOf<Element>}
         */
        let custom__link = document.querySelectorAll('.custom__link')
        custom__link.forEach((item) => {
            item.addEventListener('click', (e) => {
                let url = item.dataset.url
                Turbolinks.visit(url)
            })
        })

        /**
         * Envoi de document au collaborateur
         */
        if ($("[is='sendEmail']")) {
            import('modules/sendMail').then((module) => {
                module.sendMailToPersonnel()
            }).catch(error => {
                console.error('Error loading custom function:', error);
            });
        }

        /**
         * Dynamic form submit on change
         */
        if ($("form#dynamic__search")) {
            import('functions/form').then((module) => {
                module.dynamicFormSubmitOnChange()
            }).catch(error => {
                console.error('Error loading custom function:', error);
            });
        }
    }
)

Turbolinks.start()
